import {
  PowerBIAnalytics,
  PremiumAnalyticsPages,
} from "@components/analytics/power-bi/power-bi-analytics";

/** Renders groups analytics under groups tab in analytics page*/
export function GroupsAnalytics(): JSX.Element {
  return <PowerBIAnalytics pageDisplayName={PremiumAnalyticsPages.groups} />;
}
